export const BADGE_TIER_OPTIONS = [
  { value: 'gold', label: '金徽章' },
  { value: 'silver', label: '银徽章' },
  { value: 'bronze', label: '铜徽章' }
]

export const AWARD_MODE_RULES = {
  score: {
    label: '按总得分',
    template: (g, s, b) => `总得分率：金≥${g}%，银≥${s}%，铜≥${b}%`
  },
  completion: {
    label: '按完成度',
    template: (g) => `答完全部题并提交→银；总分≥${g}%→金；未答完提交→铜`
  },
  dimension: {
    label: '按维度突出',
    template: (g, s) => `任一维度≥${g}%→金；完成或总分≥${s}%→银；其余提交→铜`
  }
}

export function badgeTierLabel(tier) {
  const found = BADGE_TIER_OPTIONS.find(o => o.value === tier)
  return found?.label || tier || ''
}

export function badgeTierClass(tier) {
  switch (tier) {
    case 'gold':
      return 'exam-badge--gold'
    case 'silver':
      return 'exam-badge--silver'
    case 'bronze':
      return 'exam-badge--bronze'
    default:
      return 'exam-badge--default'
  }
}

export async function fetchExamBadgeCatalog() {
  const res = await fetch('/api/v1/exam/guest/badge/list', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({})
  })
  const data = await res.json()
  if (data.code !== 200) {
    throw new Error(data.message || '加载徽章测评失败')
  }
  return data.data?.exams || []
}
